// services/labelService.js
import html2canvas from 'html2canvas';
import JsBarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';
import QRCode from 'qrcode';
import { toast } from 'react-toastify';
import api from '../services/api-configuration';
import UKLogo from './UKLogo.png';

export const generateQR = async (text) => {
    try {
        const options = {
            margin: 0,
            width: 200,
            height: 200,
            color: {
                dark: '#000000',
                light: '#ffffff'
            }
        };
        return await QRCode.toDataURL(text, options);
    } catch (err) {
        console.error('QR Code generation error:', err);
        return null;
    }
};

export const fetchPDIData = async (chassisNo) => {
    try {
        const response = await api.post('/getVehicleOrderInfo', { chassis_no: chassisNo });
        if (response.status === 200) {
            return {
                success: true,
                data: {
                    chassis_no: response.data.chassis_no || "",
                    dealer: (response.data.shipping_address === "-/" ? "" : (response.data.shipping_address || "").toLocaleUpperCase("tr-TR")),
                    brand: response.data.brand || "",
                    model: response.data.model || "",
                    groupage_no: response.data.chassis_no || "",
                    pdi_date: response.data.pdi_exit_date
                        ? new Date(response.data.pdi_exit_date).toLocaleDateString('en-US', {
                            weekday: 'long',
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric',
                        })
                        : "",
                    warehouse: response.data.warehouse || "",
                    adress: response.data.address_code || ""
                }
            };
        }
        throw new Error('API response was not ok');
    } catch (error) {
        console.error('Error fetching PDI data:', error);
        toast.error('Veri çekilirken bir hata oluştu');
        return null;
    }
};

const createBarcodeImage = async (groupageNo) => {
    const canvas = document.createElement('canvas');
    canvas.style.width = '315px';
    canvas.style.height = '157px';
    const scale = window.devicePixelRatio || 2;
    canvas.width = 315 * scale;
    canvas.height = 157 * scale;

    JsBarcode(canvas, groupageNo, {
        format: 'CODE128',
        width: 3.15,
        height: 110,
        displayValue: true,
        fontSize: 25,
        textMargin: 6.3,
        margin: 0,
        background: '#ffffff',
        lineColor: '#000000'
    });

    // Rotate barcode
    const rotatedCanvas = document.createElement('canvas');
    const ctx = rotatedCanvas.getContext('2d');
    ctx.imageSmoothingEnabled = false;

    rotatedCanvas.width = canvas.height;
    rotatedCanvas.height = canvas.width;
    rotatedCanvas.style.width = canvas.style.height;
    rotatedCanvas.style.height = canvas.style.width;

    ctx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);
    ctx.rotate(-Math.PI / 2);
    ctx.drawImage(canvas, -canvas.width / 2, -canvas.height / 2);

    return rotatedCanvas.toDataURL();
};

const createLabelContainer = (data, qrImage, barcodeImage) => {
    const container = document.createElement('div');
    container.innerHTML = `
        <div style="width: 95mm; height: 125mm; font-family: sans-serif; padding: 2mm 6mm 0mm 3mm;">
            <div style="padding: 0; height: 100%; display: flex; flex-direction: column;">
                <div style="display: flex; align-items: center; height: 31mm;">
                    <img alt="UK Logo" src=${UKLogo} style="height: 70%; filter: grayscale(100%) brightness(0);">
                    <div style="width:100%">
                        <div style="font-size: 28px; font-weight: 700; text-align: center; width: 100%; border: 0.5mm solid #000; padding: 2mm; margin-bottom: 2mm;">PDI</div>
                        <div style="font-size: 16px; font-weight: 700; padding-left: 2mm;">${data.groupage_no}</div>
                    </div>
                </div>
                <div style="flex: 1; border-top: 0.5mm solid #000; display: grid; grid-template-columns: 18mm 1fr; gap: 0mm; padding-top: 2mm; max-height: 90mm; overflow: hidden;">
                    <div style="height: 100%; display: grid; grid-template-rows: auto 1fr;">
                        <span style="font-size: 3.5mm; font-weight: 700; padding: 0 3mm">BAYİ :</span>
                        <div style="height: 80mm; padding: 2mm 0">
                            <img alt="Barkod" src="${barcodeImage}" style="height: 100%; width: 100%; object-fit: contain; max-height: 80mm;">
                        </div>
                    </div>
                    <div style="display: flex; flex-direction: column; gap: 2mm;">
                        <p style="min-height: 5mm; font-size:3mm; font-weight: 700;">${data.dealer || ""}</p>
                        <div style="display: flex; justify-content: space-between; align-items: start; gap: 2mm; padding-left: 2mm;">
                            <div style="border: 0.5mm solid #000; padding: 2mm; width: 70%; font-weight: 700;">
                                <small style="font-size: 10px; font-weight: 700; display: block;">${data.brand}</small>
                                <small style="font-size: 10px; font-weight: 700; display: block; margin-top:1mm">${data.model}</small>
                            </div>
                            <div style="width: 25%;">
                                <img alt="QR" src="${qrImage}" width="100%">
                            </div>
                        </div>
                        <div style="padding-left:2mm">
                            <div style="display:flex;justify-content:space-between;border-bottom:0.5mm solid #000;padding:2mm">
                                <small style="font-size: 10px; font-weight: 700; display: block;">PDI Tarih</small>
                                <small style="font-size: 10px; font-weight: 700; display: block;">PDI Bölgesi</small>
                            </div>
                            <div style="display:flex;justify-content:space-between;padding:2mm; padding-inline:0;">
                                <small style="font-size: 10px; font-weight: 700; display: block;">${data.pdi_date}</small>
                                <small style="font-size: 10px; font-weight: 700; display: block;">${data.warehouse}</small>
                            </div>
                            <div style="font-size: 50px; font-weight: bold; text-align: left; margin-top: 3mm;">${data.adress}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    return container;
};

const generateAndSendPrint = async (container, chassisNo) => {

    try {
        const canvas = await html2canvas(container, {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: true,
            width: 357.165,
            height: 470.866,
        });

        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: [95, 125]
        });

        pdf.addImage(imgData, 'JPEG', 0, 0, 95, 125);

        const timestamp = new Date().toLocaleDateString('tr-TR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
        const filename = `pdi-${chassisNo}-${timestamp}.pdf`;

        // Convert PDF to blob
        const pdfBlob = pdf.output('blob');
        const formData = new FormData();
        formData.append('file', pdfBlob, filename);

        const uploadResponse = await api.post('/pdi-upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        if (uploadResponse.status === 200 && uploadResponse.data?.url) {
            const printResponse = await api.post('/pdi-print', {
                FilePath: uploadResponse.data.url
            });

            if (printResponse.status === 200) {
                toast.success('Etiket başarıyla yazdırıldı');
                return true;
            }
            throw new Error('Failed to send print request');
        }
        throw new Error('Failed to upload PDF or URL not received');
    } catch (error) {
        console.error('Error in print process:', error);
        toast.error('Etiket yazdırılırken bir hata oluştu');
        return false;
    }
};

export const printLabel = async (chassisNo) => {

    try {
        const pdiData = await fetchPDIData(chassisNo);
        if (!pdiData || !pdiData.success) return false;

        const { data } = pdiData;
        const qrImage = await generateQR(data.groupage_no);
        if (!qrImage) return false;

        const barcodeImage = await createBarcodeImage(data.groupage_no);
        const container = createLabelContainer(data, qrImage, barcodeImage);

        document.body.appendChild(container);
        const success = await generateAndSendPrint(container, chassisNo);
        document.body.removeChild(container);

        return success;
    } catch (error) {
        console.error('Error in label printing process:', error);
        toast.error('Etiket yazdırma işlemi başarısız oldu');
        return false;
    }
};